import TaskComments from 'pages/tasks/task-detail/parts/TaskComments';

/**
 * Comments tab in the task detail page.
 */
export default function TaskCommentsTab() {
  return <TaskComments />;
}
